import {Component, ElementRef, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ImagingToolEvent} from '../models/imaging-tool.event';
import {MatSliderChange} from '@angular/material/slider';
import {BehaviorSubject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {MessagingService} from '../../../services/messaging.service';
import {MessagingConstants} from '../../../models/MessagingConstants';

@Component({
  standalone: false,
  selector: 'app-imaging-tools-menu',
  templateUrl: './imaging-tools-menu.component.html',
  styleUrls: ['./imaging-tools-menu.component.scss']
})
export class ImagingToolsMenuComponent implements OnInit {
  @Input() parentContainer: HTMLDivElement;
  @Input() currentStrokeWidth = 2;
  @Input() contrastVal: number = 0;
  @Input() brightnessVal: number = 0;
  @Input() gammaVal: number = 100;
  @Input() currentColorSelection: string;
  @Input() secondaryColorSelection: string;
  @Input() sharpnessVal: number;
  @Input() isRotationStop: boolean = false;
  @Output() drawingToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() orientationToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() canvasToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() adjustmentToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() textToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() magnificationToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() functionToolEvent = new EventEmitter<ImagingToolEvent>();
  @Output() attributeEvent = new EventEmitter<ImagingToolEvent>();
  // @Output() valueChange = new EventEmitter<ImagingToolEvent>();

  isBottomMenuExpanded = false;
  // currentColorSelection: string;

  scale = 100;
  Widths = [];
  useMouse: boolean = false;
  selectedTool = '';

  isBrightnessOver: boolean = false;
  isContrastOver: boolean = false;
  isGammaOver: boolean = false;
  brightnessValueSubject = new BehaviorSubject<number>(0);
  contrastValueSubject = new BehaviorSubject<number>(0);
  gammaValueSubject = new BehaviorSubject<number>(100);
  bottomMenuOpen: string;
  messagingSubscription: any;

  constructor(private readonly messagingService: MessagingService) {}

  ngOnInit(): void {
    this.messagingSubscription = this.messagingService.componentMessageCall.subscribe(
      response => {
        if (response.event === MessagingConstants.STUDIO_STOP_IMAGE_ROTATION) {
          this.selectedTool = 'pointer';
        }
      }
    );
    this.getBottomMenuLocalStorage();
    for (let i = 1; i <= 20; i++) {
      let newWidth = {
        value: i
      }
      this.Widths.push(newWidth);
    }
    this.currentStrokeWidth = 2;
    // https://stackoverflow.com/questions/54709463/mat-slider-change-event-triggered-too-often
    this.brightnessValueSubject.pipe(debounceTime(150)).subscribe(value => {
      this.brightnessVal = value;
      const ie = new ImagingToolEvent();
      ie.type = 'brightness';
      ie.value = this.brightnessVal;
      this.attributeEvent.emit(ie);
    });
    this.contrastValueSubject.pipe(debounceTime(150)).subscribe(value => {
      this.contrastVal = value;
      const ie = new ImagingToolEvent();
      ie.type = 'contrast';
      ie.value = this.contrastVal;
      this.attributeEvent.emit(ie);
    });
    this.gammaValueSubject.pipe(debounceTime(150)).subscribe(value => {
      this.gammaVal = value;
      const ie = new ImagingToolEvent();
      ie.type = 'gamma';
      ie.value = this.gammaVal;
      this.attributeEvent.emit(ie);
    });
  }

  ngAfterViewInit() {
    //TX-3673 - Make free hand the default tool in the drawing tool and not the select.
    this.selectedTool = 'multi-point-line';
  }

  getBottomMenuLocalStorage() {
    this.bottomMenuOpen = localStorage.getItem('studio_bottom_menu_open');
    if (!this.bottomMenuOpen) {
      // if no setting found open bottom menu
      this.isBottomMenuExpanded = true;
    }
    else {
      if ( this.bottomMenuOpen === 'undefined') {
        // if no setting found open bottom menu
        this.isBottomMenuExpanded = true;
      }
      else {
        // this.bottomMenuOpen = JSON.parse(this.bottomMenuOpen);
        if (this.bottomMenuOpen.toLowerCase() === 'true') {
          this.isBottomMenuExpanded = true;
        }
        else {
          this.isBottomMenuExpanded = false;
        }

      }
    }

  }
  onClickOutside() {
    //this.isBottomMenuExpanded = false;
  }

  onBottomMenuClick(): void {
    this.isBottomMenuExpanded = !this.isBottomMenuExpanded;
    localStorage.setItem('studio_bottom_menu_open', JSON.stringify(this.isBottomMenuExpanded));
  }

  onDrawingToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.drawingToolEvent.emit(ie);
  }

  onOrientationToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.orientationToolEvent.emit(ie);
  }

  onCanvasToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.canvasToolEvent.emit(ie);
  }

  onAdjustmentToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.adjustmentToolEvent.emit(ie);
  }

  onTextToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.textToolEvent.emit(ie);
  }

  onMagnificationToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.magnificationToolEvent.emit(ie);
  }

  onFunctionToolClick(value: string) {
    this.selectedTool = value;
    const ie = new ImagingToolEvent();
    ie.type = value;
    this.functionToolEvent.emit(ie);
  }

  onBestFitClick() {
    const ie = new ImagingToolEvent();
    ie.type = 'best-fit';
    this.attributeEvent.emit(ie);
  }

  onScaleChange(event: MatSliderChange) {
    this.scale = event.value;
    console.log('Scale change: ' + this.scale);
  }

  onBrightnessChange(event: MatSliderChange) {
    this.brightnessValueSubject.next(event.value);
    // this.brightnessVal = event.value;
    // const ie = new ImagingToolEvent();
    // ie.type = 'brightness';
    // ie.value = this.brightnessVal;
    // this.attributeEvent.emit(ie);

  }

  onContrastChange(event: MatSliderChange) {
    this.contrastValueSubject.next(event.value);
    // this.contrastVal = event.value;
    // const ie = new ImagingToolEvent();
    // ie.type = 'contrast';
    // ie.value = this.contrastVal;
    // this.attributeEvent.emit(ie);

  }

  onGammaChange(event: MatSliderChange) {
    this.gammaValueSubject.next(event.value);
    // this.gammaVal = event.value;
    // const ie = new ImagingToolEvent();
    // ie.type = 'gamma';
    // ie.value = this.gammaVal;
    // this.attributeEvent.emit(ie);

  }
  useMouseEvent(useMouse) {
    this.useMouse = useMouse;
    console.log('useMouseEvent: ' + this.useMouse);
    const ie = new ImagingToolEvent();
    ie.type = 'use-mouse';
    ie.value = this.useMouse;
    this.attributeEvent.emit(ie);

  }

  onStrokeWidthChange(e) {
    this.currentStrokeWidth = e.value;
    console.log('currentStrokeWidth = ' + this.currentStrokeWidth);
    const ie = new ImagingToolEvent();
    ie.type = 'line-size';
    ie.value = this.currentStrokeWidth;
    this.attributeEvent.emit(ie);
  }

  onColorChange(e) {
    console.log('color changed = ' + e);
    this.currentColorSelection = e;
    const ie = new ImagingToolEvent();
    ie.type = 'color';
    ie.value = e;
    this.attributeEvent.emit(ie);
  }

  onTextColorChange(e) {
    console.log('text color changed = ' + e);
    this.secondaryColorSelection = e;
    const ie = new ImagingToolEvent();
    ie.type = 'text-color';
    ie.value = e;
    this.attributeEvent.emit(ie);
  }

  onBrightnessMouseOver(event: MouseEvent) {

  }
}
